import { useEffect, useState } from "react"

/**
 * `value` as it was once it stopped changing for `delay` milliseconds.
 *
 * The first value is returned straight away rather than after a delay: a screen
 * that debounces what it asks for still asks on arrival, and waiting would show
 * an empty state for a pause nobody caused.
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [settled, setSettled] = useState(value)

  useEffect(() => {
    if (value === settled) return

    const timer = setTimeout(() => setSettled(value), delay)
    return () => clearTimeout(timer)
  }, [value, settled, delay])

  return settled
}
